/**
 * <dd-review-summary> — PDP strip: stars + quality label, scrolls to #reviews.
 * Review photo avatars were removed from this strip (kept off by design).
 *
 * Attributes: data-product-id (reserved), data-api-url (reserved)
 */
if (!customElements.get('dd-review-summary')) {
  class DDReviewSummary extends HTMLElement {
    connectedCallback() {
      this._bindScrollToReviews();
    }

    /**
     * Intercept clicks on the `.dd-review-summary__hit` anchor so we smooth-
     * scroll to `#reviews` instead of the browser's instant hash jump. Keeps
     * the URL hash in sync (push, not replace) so back-button still works,
     * and respects `prefers-reduced-motion` by falling through to the
     * native jump. `scroll-margin-top` on `.dd-reviews-section` keeps the
     * heading clear of the sticky header.
     */
    _bindScrollToReviews() {
      const hit = this.querySelector('a.dd-review-summary__hit[href="#reviews"]');
      if (!hit) return;
      hit.addEventListener('click', (e) => {
        const target = document.getElementById('reviews');
        if (!target) return;
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        // Keep a real history entry so the hash is shareable / back-button works.
        if (window.location.hash !== '#reviews') {
          history.pushState(null, '', '#reviews');
        }
      });
    }
  }

  customElements.define('dd-review-summary', DDReviewSummary);
}
